import { render } from "./CourseDetailsDynamic.vue?vue&type=template&id=6bc532da&scoped=true"
import script from "./CourseDetailsDynamic.vue?vue&type=script&lang=js"
export * from "./CourseDetailsDynamic.vue?vue&type=script&lang=js"

import "./CourseDetailsDynamic.vue?vue&type=style&index=0&id=6bc532da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc532da"]])

export default __exports__